module.exports = __webpack_public_path__ + "img/3_Bericht_Fahrzeit.48154fac.svg";